import { Loader, CategoryPage } from '@monorepo-nx/std-watch/ui'
import { useRouter } from 'next/router';
import { AppContext, CategoryPageSEO, getAuthors, getCategoryPageBySlug, getMenuByName, getPostsByCategorySubcategorySlug } from "@monorepo-nx/std-watch/services"
import { useContext } from 'react';
import moment from 'moment';
import {Layout} from '@monorepo-nx/std-watch/ui';



const SubCategoryPage = ({ posts, authors, categoryPage, category, subCategory, pagination, mainMenu }) => {
  const router = useRouter();
  

  const { setCategoryPageData } = useContext(AppContext);
  setCategoryPageData(categoryPage)
  
  if (router.isFallback) {
    return <Loader />;

  }
console.log(subCategory);
  return (
    <Layout mainMenu={mainMenu}>
     <CategoryPageSEO
        title={subCategory}
        category={category}
        currentPage={pagination.currentPage} 
        coverImage={posts[0]?.coverImage}
        pagesCount={pagination.pagesCount}
        subCategory={subCategory} 
        dateModified={posts[0]?.createdAt ? moment(posts[0].createdAt).format('MMM DD, YYYY') : undefined}
        />

      <CategoryPage
        posts={posts}
        authors={authors}
        category={category}
        pagination={{
          pagesCount: pagination.pagesCount,
          total: pagination.total,
          pageSize: pagination.pageSize,
          currentPage:pagination.currentPage,
          prefix: `/${category}/${subCategory}`
        }}
        categoryPage={categoryPage}
      />
    </Layout>
  );
}


export default SubCategoryPage;

export async function getServerSideProps({ req, res, params, query }) {
  const pageSize = query.pageSize || 19;
  const currentPage = query.page ? parseInt(query.page, 10) : 1;
  const skip = (currentPage - 1) * pageSize;
  if (skip < 0){
    return {
      notFound: true,
    }
  }
  const [authors, { categoryPage }, { posts, aggregate }, mainMenuData, footerData] = await Promise.all([
    getAuthors(),
    getCategoryPageBySlug(params.categorySlug),
    getPostsByCategorySubcategorySlug({...params, skip, limit: pageSize}),
    getMenuByName("Main"),
    getMenuByName("Footer"),
  ])


  res.setHeader(
    'Cache-Control',
    'public, s-maxage=3600, stale-while-revalidate=7200'
  )

  return {
    props: {
      posts,
      authors,
      category: params.categorySlug,
      subCategory: params.subcategorySlug,
      categoryPage,
      pagination: {
        total: aggregate.count,
        pagesCount: Math.ceil(aggregate.count / pageSize),
        currentPage,
        pageSize,
      },
      mainMenu: mainMenuData.content,
      footer: footerData.content,

    },
  };
}




